module.exports = __webpack_public_path__ + "static/media/Azure_contentsPage_en.62a18288.png";